import React from "react";
import {Link} from "react-router-dom";
import "./style.css";

const Footer = () => {
  return (
    <footer className="bg-dark text-light py-3">
      <div className="container d-lg-flex align-items-center justify-content-between py-3 small text-center">
        <div className="text-white mb-2 mb-lg-0">
          Copyright &copy; {new Date().getFullYear()} Beryls Management - All rights reserved
        </div>
        <div className="text-white">
          <Link
            to="/terms-and-conditions"
            className="text-white mx-2 hove"
            style={{ fontSize: "0.875rem", textDecoration: "none" }}
          >
            Terms & Conditions
          </Link>
          <span className="mx-2">|</span>
          <Link
            to="/privacy-policy"
            className="text-white mx-2 hove"
            style={{ fontSize: "0.875rem",  textDecoration: "none" }}
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
